import { render, staticRenderFns } from "./dados-complementares.vue?vue&type=template&id=5be1317a&"
import script from "./dados-complementares.vue?vue&type=script&lang=js&"
export * from "./dados-complementares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports